import * as React from 'react';
import {Link} from 'react-router-dom';

import {BackButton} from '../button/back-button/back-button';
import {InfoIcon} from '../icon/svg/info-icon';
import {Stack} from '../layout/stack/stack';

import styles from './page-header.module.css';

type Props = {
    backButton?: {
        to?: string;
        onClick?: () => void;
        text?: string;
        getRef?: (node?: HTMLElement | null | undefined) => void;
    };
    title: string;
    titleTooltip?: string;
    subtitle?: string | React.ReactNode;
    actionButtons?: React.ReactNode;
};

export function PageHeader(props: Props) {
    const {backButton, subtitle, actionButtons} = props;

    return (
        <header className={styles.container}>
            {backButton ? (
                <div className={styles.left}>
                    <BackButton
                        // @ts-expect-error
                        as={backButton.to ? Link : 'button'}
                        to={backButton.to}
                        onClick={backButton.onClick}
                        backText={backButton.text ? backButton.text : 'Back'}
                        getRef={backButton.getRef}
                    />
                </div>
            ) : (
                // Need a div here, or we wont space our other elements
                // correctly
                <div className={styles.left} />
            )}
            <div className={styles['title-container']}>
                <Stack isHorizontal={true} alignItems='center' justifyContent='center' spacing={4}>
                    <div className={styles.title}>{props.title}</div>
                    {props.titleTooltip && (
                        <div data-tip={props.titleTooltip} data-place='bottom' className='pt-4'>
                            <InfoIcon size={20} />
                        </div>
                    )}
                </Stack>
                {subtitle ? <div className={styles.subtitle}>{subtitle}</div> : undefined}
            </div>
            {actionButtons ? (
                <div className={styles.right}>{actionButtons}</div>
            ) : (
                <div className={styles.right} />
            )}
        </header>
    );
}
